<template>
  <b-form-input
    :id="id"
    :name="name"
    type="text"
    :value="displayValue"
    :class="inputClass"
    @input="onInput"
    @blur="onBlur"
  />
</template>

<script>
export default {
  name: "CurrencyInput",

  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    id: String,
    name: String,
    inputClass: {
      type: [String, Object],
      default: () => "form-control",
    },
    prefix: {
      type: String,
      default: "Rp ",
    },
  },

  data() {
    return {
      isEditing: false,
    };
  },

  computed: {
    displayValue() {
      // Saat user sedang hapus → biarkan kosong
      if (this.isEditing && (!this.value || this.value === 0)) {
        return "";
      }

      const numberValue = Number(this.value) || 0;
      return this.formatRupiah(String(numberValue));
    },
  },

  methods: {
    onInput(val) {
      this.isEditing = true;

      const numeric = val.replace(/[^0-9]/g, "");

      // kirim 0 kalau kosong
      this.$emit("input", numeric ? Number(numeric) : 0);
    },

    onBlur() {
      this.isEditing = false;

      // Kalau kosong → paksa jadi 0
      if (!this.value) {
        this.$emit("input", 0);
      }

      this.$emit("blur");
    },

    formatRupiah(angka) {
      return (
        this.prefix +
        angka.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      );
    },
  },
};
</script>